import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class RedirectService extends RestfulService<Models.Redirect> {

  constructor(private restService: RestService) {
    super(Models.Redirect);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('redirects');
  }

}
